module.exports = "<!-- Main Blocks -->\r\n\r\n<router-outlet (activate)=\"onActivate($event)\"></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main